
















































import { Vue, Component, Prop } from 'vue-property-decorator';
import { VueEditor } from 'vue2-editor';
import { vxm } from '@/store.vuex';
import avatar from 'vue-avatar';
import axios from 'axios';
import Multiselect from 'vue-multiselect';

@Component({
  components: {
    avatar,
    VueEditor,
    Multiselect,
  },
})
export default class EditEditor extends Vue {
  @Prop({}) editPostId;
  mounted() {
    this.getPost();
  }
  private selectedCategory: any = {};
  private forumPostData: String = '';
  private title: String = '';
  private postInfo: any = {
    forumPost: String,
    action: String,
    companyCode: String,
    userId: Number,
    postId: Number,
    title: String,
    categoryId: Number || String,
  };
  $wlToastr: any;

  get customToolbar() {
    return [
      vxm.configs.getGlobalConfigBooelanValue('WL_ENABLE_FORUM_MEDIA_CANDIDATE')
        ? ['image']
        : [],
    ];
  }

  get placeholder() {
    return this.$t('forum-post-placeholder');
  }

  async savePost() {
    if (this.forumPostData === '') {
      this.$wlToastr('error', this.$t('forum-please-write-a-post'), '');
      return;
    } else {
      //this.postInfo.forumPost =  $('.ql-editor')[0].innerHTML;
      this.postInfo.forumPost = this.forumPostData;
      this.postInfo.action = 'create';
      this.postInfo.companyCode = vxm.jobs.BrandingInfo.companycode;
      this.postInfo.userId = vxm.users.myUserProfile.userId;
      this.postInfo.postId = this.editPostId;
      this.postInfo.title = this.title;
      this.postInfo.categoryId = this.selectedCategory.forumCategoryId;
      const respPromise: any = vxm.forum.editPost(this.postInfo);
      const resp = await respPromise;
      if (resp.success) {
        this.$wlToastr('success', resp.successMessage, '');
        if (this.$route.params.postId) {
          vxm.forum.resetPostList([resp.forumPostResponse]);
        } else {
          vxm.forum.loadPosts({ initCall: true });
        }
      } else {
        this.$wlToastr('error', resp.errorMessage, '');
      }
      this.postInfo = {};
      this.$bvModal.hide('modal-edit-post');
    }
  }
  async getPost() {
    let resp: any = await vxm.forum.getPost(this.editPostId);
    this.forumPostData = resp.body;
    this.title = resp.title;
    this.selectedCategory = {
      forumCategoryTitle: resp.categoryName || 'General',
      forumCategoryId: resp.categoryId || 0,
    };
    console.log(this.editPostId);
  }
  cancelCreatePost() {
    this.postInfo = {};
    this.postInfo.action = 'cancel';
    this.$bvModal.hide('modal-edit-post');
  }
  handleImageAdded(file, Editor, cursorLocation, resetUploader) {
    var formData = new FormData();
    formData.append('file', file);
    axios({
      url: `/forum/api/v1/posts/uploadimage?companyCode=${
        vxm.jobs.BrandingInfo.companycode
      }`,
      method: 'POST',
      data: formData,
      headers: {
        'app-agent': 'CANDIDATE-PORTAL',
      },
    })
      .then((result) => {
        if (result && result.data && !result.data.success) {
          this.$wlToastr('error', result.data.errorMessage);
          return;
        }
        let url = result.data.imagePath; // Get url from response
        Editor.insertEmbed(cursorLocation, 'image', url);
        resetUploader();
      })
      .catch((e) => {
        if (e && e.response && (e.response.status === 503 || e.response.status === 418)) {
          this.$wlToastr(
            'error',
            this.$t('ResumeDetails_SecurityRisk'),
          );
        }
        if (e && e.response && e.response.data && e.response.data.message) {
          this.$wlToastr('error', e.response.data.message);
        }
      });
  }
  get categories() {
    return vxm.forum.Categories.filter((category) => {
      return category.restrictedTo !== 1;
    });
  }
}
